import { INITIAL_SETUP_OPENED } from './initialSetupSegmentEvents';
import './initialSetup.scss';
export class InitialSetupController {
    static $inject = ['SegmentService', 'AccountService2'];
    constructor(SegmentService, AccountService2) {
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.initialized = false;
        this.year = new Date().getFullYear();
    }
    async $onInit() {
        const account = await this.AccountService2.me();
        if (!this.initialized && account.extras?.initialSetupDone != 'true') {
            this.initialized = true;
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_OPENED);
        }
    }
}
InitialSetupController.$inject = ['SegmentService', 'AccountService2'];
